import DOMPurify from "isomorphic-dompurify"

// Mail, phone and in-page links keep working in the same window.
const keepsWindow = (href: string) => /^(mailto:|tel:|#)/i.test(href.trim())

/**
 * Sanitizes the HTML of a product's additional information (xRM field
 * "Webshop Zusatzinformationen") and opens all its web links in a new window,
 * so customers don't leave the store. Editors usually leave the link target
 * empty in xRM, so the target set there is not used.
 */
export const sanitizeWithProductLinksInNewWindow = (html: string) => {
  const fragment = DOMPurify.sanitize(html, { RETURN_DOM_FRAGMENT: true })
  fragment.querySelectorAll("a[href]").forEach((link) => {
    if (!keepsWindow(link.getAttribute("href") ?? "")) {
      link.setAttribute("target", "_blank")
      link.setAttribute("rel", "noopener noreferrer")
    }
  })
  const container = fragment.ownerDocument.createElement("div")
  container.appendChild(fragment)
  return container.innerHTML
}
